import { SecondaryBtn } from "@/components/Global/Button";
import PrimaryBtn from "@/components/Global/Button";
import Modal from "@/components/Global/Modal";
import { TbRefresh } from "react-icons/tb";

const QuickbooksModal = ({
  handleSubmit,
  setQuickbooksSyncedModal,
  values,
  title,
  disabled,
  setFieldValue,
}) => {
  return (
    <Modal
      handleClose={() => setQuickbooksSyncedModal(false)}
      title={
        values._id && values?.quickbooks_data?.id
          ? "Update QuickBooks Record?"
          : "Sync to Quickbooks"
      }
      description={
        values._id && values?.quickbooks_data?.id
          ? `You are updating a ${title} that is synced with QuickBooks. Do you want to apply these changes to QuickBooks as well?`
          : `Are you sure you want to sync this ${title} to quickbooks?`
      }
      central={true}
      width={
        values._id && values?.quickbooks_data?.id ? "max-w-lg" : "max-w-sm"
      }
      leftAlign={true}
      inLine={true}
      icon={<TbRefresh className="text-customGreen-primary" />}
    >
      <div className="grid grid-cols-2 gap-4  mt-3">
        <SecondaryBtn
          text={
            values._id && values?.quickbooks_data?.id
              ? "No, Change in DH Only"
              : "Don't Sync"
          }
          onClick={() => {
            setFieldValue("syncQuickbooks", false);
            handleSubmit();
          }}
          disabled={disabled}
        />
        <PrimaryBtn
          text={
            values._id && values?.quickbooks_data?.id
              ? "Yes, Update Quickbooks"
              : `Sync ${title}`
          }
          onClick={() => {
            setFieldValue("syncQuickbooks", true);
            handleSubmit();
          }}
          disabled={disabled}
        />
      </div>
    </Modal>
  );
};

export default QuickbooksModal;
